import { render } from "./ProductsList.vue?vue&type=template&id=8c91b854&scoped=true"
import script from "./ProductsList.vue.ts?vue&type=script&lang=ts"
export * from "./ProductsList.vue.ts?vue&type=script&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=8c91b854&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8c91b854"

export default script